import { render, staticRenderFns } from "./SollAcademyMinhasTrilhas.vue?vue&type=template&id=6a9d3fce&scoped=true"
import script from "./SollAcademyMinhasTrilhas.vue?vue&type=script&lang=js"
export * from "./SollAcademyMinhasTrilhas.vue?vue&type=script&lang=js"
import style0 from "./SollAcademyMinhasTrilhas.vue?vue&type=style&index=0&id=6a9d3fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9d3fce",
  null
  
)

export default component.exports